import { Grid, Paper, Typography } from "@mui/material";
import { observer } from "mobx-react";
import React, { FunctionComponent } from "react";
import logo from "../../../../authenticx-green.png";
import { useStore } from "../../../../utils/useStore";
import { EvalStore } from "../../Stores/EvalStore";
import ClassifierFeedbackAnswer from "./ClassifierFeedbackAnswer";

interface OwnProps {}

type Props = OwnProps;

const ClassifierResultFeedbackCard: FunctionComponent<
    React.PropsWithChildren<React.PropsWithChildren<Props>>
> = observer((props) => {
    const store = useStore(EvalStore);

    return (
        <Paper
            sx={{
                paddingBottom: "16px",
                width: "100%",
                height: "auto",
                borderRadius: "8px",
            }}
            elevation={4}
        >
            <Grid
                container
                direction="column"
                justifyContent="flex-start"
                alignItems="stretch"
            >
                <Grid
                    item
                    xs={12}
                    container
                    wrap={"nowrap"}
                    sx={{
                        paddingLeft: 3,
                        paddingTop: 3,
                        paddingBottom: 1,
                        marginBottom: "16px",
                    }}
                >
                    <Grid item>
                        <img
                            style={{ height: 28, width: 28, marginRight: 8 }}
                            alt=""
                            src={logo}
                        />
                    </Grid>
                    <Grid item>
                        <Typography
                            variant={"h1"}
                            sx={{ fontSize: "13px", fontWeight: "bold" }}
                        >
                            Did you hear this?
                        </Typography>
                    </Grid>
                </Grid>
                <>
                    {store.allClassifiers?.map((value) => {
                        return (
                            <React.Fragment key={value.id}>
                                <ClassifierFeedbackAnswer
                                    classifierResult={value}
                                    isDisabled={!store.currentEval?.isEditable}
                                />
                            </React.Fragment>
                        );
                    })}
                </>
            </Grid>
        </Paper>
    );
});

export default ClassifierResultFeedbackCard;
